export default __webpack_public_path__ + "static/media/logo.f64ccca2.svg";